import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_refund';
export const route = 'alt_refund/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_refund" */
/* webpackPrefetch: true */
'../components/AltRefundPage')));